import { useEffect, useState } from "react";
import API from "../../../services/API/CRM";
import Layout from '../../Frames/Layout'
import { Alert, Stack, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Siret from '../../Inputs/Siret'
import Checkbox from "../../Inputs/Checkbox";
import FormButtons from "../../Inputs/FormButtons";
import Loader from "../../Tools/Loader";
import PrivatizeCheckbox from "./PrivatizeCheckbox";

export default function GroupForm(){

    const {id} = useParams()
    const navigate = useNavigate()

    const [item, setItem] = useState(null)
    const [error, setError] = useState(false)
    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {

        if(id !== 'new'){
            API.getGroup(id)
                .then(r => setItem(r.data))
                .catch(e => console.log(e.response?.data))
        }else{
            setItem({
                showTurnover: true
            })
        }
        

    }, [id])


    const handleSubmit = e => {
        e.preventDefault();

        setError(false);
        setSubmitting(true);

        (id !== 'new' ? API.putGroup(item) : API.postGroup(item))
            .then(_ => navigate('/crm/groups'))
            .catch(_ => setError(true))
            .finally(() => setSubmitting(false))

    }


    return <Layout tab='companies' menu='crm'>

        {item && <form onSubmit={handleSubmit}>

            <Stack direction='column' spacing={3} sx={{margin: 'auto'}} width={window.innerWidth > 800 ? 600 : 320}>

                <h2>Groupement</h2>

                {error && <Alert severity='error'>Une erreur s'est produite. Vérifiez que le SIRET n'est pas utilisé par une autre entreprise ou groupement.</Alert>}

                {id === 'new' &&
                    <Siret
                        value={item.id || ''}
                        onChange={value => setItem({...item, id: value})}
                        required
                    />
                }

                <TextField 
                    label='Nom'
                    value={item.name || ''}
                    onChange={e => setItem({...item, name: e.target.value})}
                    inputProps={{maxLength: 200}}
                    required
                    size='small'
                />

                <Checkbox 
                    label='Afficher le CA'
                    value={item.showTurnover}
                    onChange={v => setItem({...item, showTurnover: !item.showTurnover})}
                />

                <PrivatizeCheckbox 
                    value={item.privatize}
                    onChange={privatize => setItem({...item, privatize})}
                    companyName={item.name}
                />

                <FormButtons
                    loading={submitting}
                    onCancel={() => navigate('/crm/groups')}
                />

            </Stack>

        </form>}

        {!item && <Loader />}

    </Layout>

}


